import { AssetType, TProject } from '../types/config';
import {
  AVRAM_YZER_ID,
  HAVATZELET_YZER_ID,
  HOLON_YZER_ID,
  SHVIRO_YZER_ID,
  YUVALIM_YZER_ID,
  RASSCO_YZER_ID,
  RASSCO_NEW_YZER_ID,
  PISGAT_YZER_ID,
  SHBIRO_NEVE_ZEMER_YZER_ID,
} from '../hardcode/constants';
import { isProd } from './environment';


const hasInventory = (project?: TProject) => {
  return Boolean(project?.listings?.length);
};

const hasDescription = (project?: TProject) => {
  return Boolean(project?.description);
};

const hasInteractivePanorama = (project?: TProject) => {
  return Boolean(project?.panoramaXmlPath);
};

const hasPromotions = (project?: TProject) => {
  return Boolean(project?.projectPromotions?.length && project.promotions);
};

const hasSpecifications = (project?: TProject) => {
  return Boolean(project?.specifications?.length);
};

const hasTimeline = (project?: TProject) => {
  return Boolean(project?.timelines?.length);
};

const hasDocuments = (project?: TProject) => {
  return Boolean(
    project?.assets?.filter((a) => ['document', 'blueprint'].includes(a.type))?.length,
  );
};

const hasClients = (project?: TProject) => {
  return Boolean(project?.clients?.length && project?.clients[0]?.description);
};

const hasGallery = (project?: TProject) => {
  return project?.assets?.some((a) =>
    [AssetType.MainImage, AssetType.Gallery, AssetType.Promotion, AssetType.Blueprint].includes(
      a.type,
    ),
  );
};

const hasInteractive = (project?: TProject) => {
  const allowedIds = [
    AVRAM_YZER_ID,
    SHVIRO_YZER_ID,
    HOLON_YZER_ID,
    HAVATZELET_YZER_ID,
    YUVALIM_YZER_ID,
    SHBIRO_NEVE_ZEMER_YZER_ID,
    RASSCO_YZER_ID,
    PISGAT_YZER_ID,
    // Hide RASSCO_NEW interactive on production for now
    ...(isProd() ? [] : [ RASSCO_NEW_YZER_ID, ]),
  ];

  return allowedIds.includes(project?.yzerId as number) || !!project?.panoramaXmlPath;
};

export const projectUtils = {
  hasInventory,
  hasDescription,
  hasInteractivePanorama,
  hasPromotions,
  hasSpecifications,
  hasTimeline,
  hasDocuments,
  hasClients,
  hasGallery,
  hasInteractive,
};
